<div class="container">
  @if(textOnly) {
  <button mat-button [disabled]="true" class="text-only-button">
    <ng-container [ngTemplateOutlet]="buttonLabelTemplate"></ng-container>
  </button>
  } @else if (isSelected) {
  <button
    mat-flat-button
    color="primary"
    [disabled]="disabled"
    (click)="selectSlot()"
  >
    <ng-container [ngTemplateOutlet]="buttonLabelTemplate"></ng-container>
  </button>
  } @else {
  <button
    mat-stroked-button
    color="primary"
    [disabled]="disabled"
    (click)="selectSlot()"
  >
    <ng-container [ngTemplateOutlet]="buttonLabelTemplate"></ng-container>
  </button>
  }

  <span *ngIf="includeDiscount && !textOnly" class="discount-quarter-circle"
    >%</span
  >
</div>

<ng-template #buttonLabelTemplate>
  @if (displayTextAsDate) {
  {{ slot.getDate() }}
  } @else {
  {{ slot | timeFormatter : true }}
  }
</ng-template>
